import groupImagesByType from "./groupImagesByType";
import Image from '../models/Image';

export default function transformBusinessCard(businessCard){

    const images = businessCard.images.map(image => Image(image.type,image.baseFilename,image.images));
    const groupedImages = groupImagesByType(images);

    const transformedCard = {
        cardActions:{
            actions: businessCard.actions,
            deletedActions: []
        },
        clientInfo: Object.assign({},businessCard.clientInfo,{status: businessCard.status}),
        settings: businessCard.settings,
        //TODO: add deleted images to here
        images: Object.assign(groupedImages,{deletedImages:[]}),

    }

    return transformedCard;
}